/* eslint-disable jsx-a11y/anchor-is-valid */
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import moment, { safeClone } from 'src/utils/momentConfig';
import { DatePicker, Select } from 'antd';
import { useState, useEffect } from 'react';

import { useAuth } from 'src/app/modules/auth';
import RenderOverview from './components/RenderOverview';
import { requestPOST } from 'src/utils/baseAPI';
import RenderChartMoney from './components/RenderChartMoney';
import RenderChartVehicleInOut from './components/RenderChartVehicleInOut';
import RenderChartBarrierManual from './components/RenderChartBarrierManual';
import RenderChartActionLog from './components/RenderChartActionLog';

const DashboardPage = () => {

  const [branchs, setBranchs] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const dateFormat = 'DD/MM/YYYY';
  const { currentUser } = useAuth();
  const [fromDateToDate, setFromDateToDate] = useState({
    fromDate: moment().startOf('month'),
    toDate: moment().endOf('day'),
  });

  const onFromDateChange = (date) => {
    if (date) {
      setFromDateToDate(prev => ({
        ...prev,
        fromDate: safeClone(date).startOf('day')
      }));
    }
  };

  const onToDateChange = (date) => {
    if (date) {
      setFromDateToDate(prev => ({
        ...prev,
        toDate: safeClone(date).endOf('day')
      }));
    }
  };

  const handleBranchChange = (value) => {
    setSelectedBranch(value);
  };

  useEffect(() => {
    const fetchBranchs = async () => {
      const res = await requestPOST(`api/v1/branches/search`, {
      });
      if(res && res.data){
        setBranchs(res.data);
        // Set giá trị mặc định là "Tất cả" (null)
        setSelectedBranch(null);
      }
    };
    fetchBranchs();
  }, []);

  // Tạo options cho Select với option "Tất cả" ở đầu
  const branchOptions = [
    { value: null, label: 'Tất cả chi nhánh' },
    ...branchs.map(branch => ({
      value: branch.id,
      label: branch.name
    }))
  ];

  return (
  <>
    <div className="card card-xl-stretch mb-xl-5">
      <div className="card-header min-h-50px">
        <div className="d-flex align-items-center">
          <h3 className="card-title fw-bold text-primary me-5">Chọn chi nhánh</h3>
          <Select
            style={{ width: 200 }}
            value={selectedBranch}
            onChange={handleBranchChange}
            options={branchOptions}
            placeholder="Chọn chi nhánh"
          />
        </div>
      </div>
    </div>

    <div className="mb-5">
        <RenderOverview selectedBranch={selectedBranch} />
    </div>
    <div className={`card card-xl-stretch mb-xl-5`}>
        <div className="card-header min-h-50px">
          <h3 className="card-title fw-bold text-primary">Thống kê chung theo thời gian</h3>
          <div className="card-toolbar">
            <div className="d-flex align-items-center">
              <span className="me-2">Từ:</span>
              <DatePicker
                value={fromDateToDate.fromDate}
                onChange={onFromDateChange}
                format={dateFormat}
                placeholder="Chọn ngày bắt đầu"
                className="me-3"
                allowClear={false}
              />
              <span className="me-2">Đến:</span>
              <DatePicker
                value={fromDateToDate.toDate}
                onChange={onToDateChange}
                format={dateFormat}
                placeholder="Chọn ngày kết thúc"
                allowClear={false}
              />
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-12">
              <RenderChartMoney fromDateToDate={fromDateToDate} selectedBranch={selectedBranch} />
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <RenderChartVehicleInOut fromDateToDate={fromDateToDate} selectedBranch={selectedBranch} />
            </div>
            {/* <div className="col-lg-6">
              <RenderChartBarrierManual fromDateToDate={fromDateToDate} selectedBranch={selectedBranch} />
            </div> */}
          </div>
          <div className="row">
            <div className="col-12">
              <RenderChartActionLog fromDateToDate={fromDateToDate} selectedBranch={selectedBranch} />
            </div>
          </div>
        </div>
      </div>
  </>)
}

const DashboardWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
